import { Scene } from 'phaser'
import { store } from '@/store/store'

function setLoadingFalse() {
  store.dispatch('updateLoader', false)
}

export default class PlayScene extends Scene {
  constructor () {
    super({ key: 'PlayScene' })
  }

  init () {
    this.StageHeight = this.sys.game.config.height
    this.StageWidth = this.sys.game.config.width
  }

  preload () {
    this.gameDetails = {
      paddingLeft: 50,
      marginSides: 10,
      bottomHeight: 380,
      levelHeight: 65,
      TowerImageWidth: 666,
      TowerWidth: 220,
    }
  }

  create () {
    setLoadingFalse()

    this.TowerOneX = (this.gameDetails.TowerWidth - (this.gameDetails.TowerWidth/2)) + this.gameDetails.paddingLeft
    this.TowerTwoX = ((this.gameDetails.TowerWidth * 2) - (this.gameDetails.TowerWidth/2)) + this.gameDetails.paddingLeft
    this.TowerThreeX = ((this.gameDetails.TowerWidth * 3) - (this.gameDetails.TowerWidth/2)) + this.gameDetails.paddingLeft

    this.post = this.add.group({
      key: 'post',
      repeat: 2,
      setXY: {
        x: this.TowerOneX,
        y: this.StageHeight - 150,
        stepX: this.gameDetails.TowerWidth
      }
    })

    this.scale = ((this.gameDetails.TowerWidth - this.gameDetails.marginSides) / this.gameDetails.TowerImageWidth) - 1
    Phaser.Actions.ScaleXY(this.post.getChildren(), this.scale, this.scale)
  
    this.totalLevels = 3
    this.maxLevel = 3
    this.moveCount = 0
  
    this.sections = (this.StageWidth - this.gameDetails.paddingLeft) / 3
  
    // create levels
    this.levelsArray = [
      {
        spriteName: 'small',
        blockSize: 1
      },
      {
        spriteName: 'medium',
        blockSize: 2
      },
      {
        spriteName: 'large',
        blockSize: 3
      }
    ]

    this.startTimer()
    this.createLoayout()
  
    this.input.on('dragstart', function (pointer, gameObject) {
    }, this)
  
    this.input.on('drag', function (pointer, gameObject, dragX, dragY) {
      if (this.checkIsLowestPickup(gameObject)) {
        gameObject.x = dragX
        gameObject.y = dragY
      }
    }, this)
  
    this.input.on('dragend', function (pointer, gameObject) {
      if (this.checkIsLowestPickup(gameObject)) {
        this.moveToTowerCalculate(pointer, gameObject)
      }
    }, this)
  }
  
  startTimer () {
    this.gameTimer = 0
    this.runTimer = true

    var gameClock = setInterval(() => {
      this.gameTimer++
      // this.timeText.setText('Timer: ' + this.gameTimer + 's')
      if (!this.runTimer) {
        clearInterval(gameClock)
      }
    }, 1000)
  }

  createLoayout () {
    this.tower1Array = []
    this.tower2Array = []
    this.tower3Array = []

    for (let i = 0; i < this.totalLevels; i++) {
      this.singleLevel = this.add.sprite( 
        this.TowerOneX,
        this.gameDetails.bottomHeight - (this.gameDetails.levelHeight * (this.totalLevels - (1 + i))),
        this.levelsArray[i].spriteName,
        0
      ).setInteractive()
      this.singleLevel.towerItem = 'tower1Array'
      this.singleLevel.levelSize = this.levelsArray[i].blockSize
      this.singleLevel.newTower = null
      this.singleLevel.setScale(this.scale + 1)
      this.singleLevel.setDepth((this.totalLevels + 5) - i)

      this.tower1Array.push(this.singleLevel)
      this.input.setDraggable(this.singleLevel)
    }
  }

  updateMoveCount () {
    this.moveCount++
  }

  moveToTowerCalculate (pointer, gameObject) {
    if (pointer.upX < this.gameDetails.paddingLeft) {
      // if too far left go back
      this.returnToTower(pointer, gameObject)
    } else if ((this.gameDetails.TowerWidth + this.gameDetails.paddingLeft) > pointer.upX) {
      // if original tower, cancel update
      if (gameObject.towerItem === 'tower1Array' || this.checkIsLowestDrop(gameObject, this.tower1Array)) {
        this.returnToTower(pointer, gameObject)
        return
      }
      this.placeLevel(gameObject, this.TowerOneX, 'tower1Array')
      this.updateMoveCount()
    } else if (((this.gameDetails.TowerWidth * 2) + this.gameDetails.paddingLeft) > pointer.upX) {
      if (gameObject.towerItem === 'tower2Array' || this.checkIsLowestDrop(gameObject, this.tower2Array)) {
        this.returnToTower(pointer, gameObject)
        return
      }
      this.placeLevel(gameObject, this.TowerTwoX, 'tower2Array')
      this.updateMoveCount()
    } else if (((this.gameDetails.TowerWidth * 3) + this.gameDetails.paddingLeft) > pointer.upX) {
      if (gameObject.towerItem === 'tower3Array' || this.checkIsLowestDrop(gameObject, this.tower3Array)) {
        this.returnToTower(pointer, gameObject)
        return
      }
      this.placeLevel(gameObject, this.TowerThreeX, 'tower3Array')
      this.updateMoveCount()
    } else {
      // this will be too far to the right
      this.returnToTower(pointer, gameObject)
    }
  
    if (this.totalLevels === this.tower3Array.length) {
      if (this.totalLevels < this.maxLevel) {
        this.totalLevels++
        for (var i = 0; i < this.tower3Array.length; i += 1) {
          this.tower3Array[i].destroy()
        }
        this.createLoayout()
      } else {
        this.endGame()
      }
    }
  }
  
  placeLevel (gameObject, towerX, newArrayName) {
    gameObject.x = towerX
    gameObject.y = this.gameDetails.bottomHeight - (this.gameDetails.levelHeight * this[newArrayName].length)
    this[gameObject.towerItem].splice(this.findInTowerArray(gameObject), 1)
    gameObject.towerItem = newArrayName
    this[newArrayName].unshift(gameObject)
  }

  findInTowerArray (gameObject) {
    var towerArray = this.tower1Array
    if (gameObject.towerItem === 'tower2Array') {
      towerArray = this.tower2Array
    } else if (gameObject.towerItem === 'tower3Array') {
      towerArray = this.tower3Array
    }
  
    for (var i = 0; i < towerArray.length; i += 1) {
      if (towerArray[i].levelSize === gameObject.levelSize) {
        return i
      }
    }
    return -1
  }

  checkIsLowestPickup (gameObject) {
    var towerArray = this.tower1Array
    if (gameObject.towerItem === 'tower2Array') {
      towerArray = this.tower2Array
    } else if (gameObject.towerItem === 'tower3Array') {
      towerArray = this.tower3Array
    }
  
    for (var i = 0; i < towerArray.length; i += 1) {
      if (towerArray[i].levelSize < gameObject.levelSize) {
        return false
      }
    }
    return true
  }

  checkIsLowestDrop (gameObject, levelsArray) {
    if (levelsArray.length === 0) {
      return false
    }
    for (var i = 0; i < levelsArray.length; i += 1) {
      if (levelsArray[i].levelSize < gameObject.levelSize) {
        return true
      }
    }
    return false
  }

  restartLevel () {
    this.clearBoard()
    setTimeout(() => {
      this.createLoayout()
    }, 100)
  }

  clearBoard () {
    this.tower1Array.forEach(element => {
      element.destroy()
    })
    this.tower2Array.forEach(element => {
      element.destroy()
    })
    this.tower3Array.forEach(element => {
      element.destroy()
    })
  }

  destroyGame () {
    this.sys.game.destroy(true);
  }

  endGame (gameObject, levelsArray) {
    this.runTimer = false
    this.time.addEvent({
      delay: 250,
      callbackScope: this,
      callback: function () {
        this.scene.start('EndScene', { time: this.gameTimer, moves: this.moveCount })
      }
    })
  }

  returnToTower (pointer, gameObject) {
    gameObject.y = gameObject.input.dragStartY
    if (gameObject.towerItem === 'tower1Array') {
      gameObject.x = this.TowerOneX
    } else if (gameObject.towerItem === 'tower2Array') {
      gameObject.x = this.TowerTwoX
    } else {
      gameObject.x = this.TowerThreeX
    }
  }
}